import React from 'react';
import Button from '@mui/material/Button';

function CustomButton({ children, onClick, buttonColor, hoverColor, small = false, ...otherProps }) {
  try {
    return (
      <Button
        {...otherProps}
        onClick={onClick}
        sx={{
          width: '100%',
          minHeight: small ? '32px' : '56px',
          fontSize: '16px',
          textTransform: 'uppercase',
          fontWeight: 700,
          borderColor: theme => theme.palette.primary.main,
          background: buttonColor,
          '&:hover': {
            background: hoverColor || (theme => theme.palette.additionalColors.darkMain),
            color: theme => theme.palette.primary.softText,
          },
        }}
      >
        {children}
      </Button>
    );
  } catch (error) {
    console.error('❌ Erro no componente CustomButton:', error);
    return null;
  }
}

export default CustomButton;
